import script from "./noticeToolModal.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeToolModal.vue?vue&type=script&setup=true&lang=js"

import "./noticeToolModal.vue?vue&type=style&index=0&id=777deaa4&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777deaa4"]])

export default __exports__